import { z } from 'zod';

import { Position } from '../../roster';
import { SessionType } from '../../sessions';

export type PlayerReportScope = z.infer<typeof playerReportScopeSchema>;

export const playerReportScopeSchema = z.enum(['1M', '3M', '6M']);

export type PlayerReportDataQuery = z.output<typeof playerReportDataQuerySchema>;
export type PlayerReportDataQueryDTO = z.input<typeof playerReportDataQuerySchema>;

export const playerReportDataQuerySchema = z.object({
  contextType: z.enum(['player', 'group', 'team', 'position']).optional(),
  contextId: z.uuid().optional(),
  contextPosition: z.enum(Position).optional(),
  scope: playerReportScopeSchema.catch('1M'),
  sessionTypes: z.union([z.enum(SessionType), z.array(z.enum(SessionType))]).catch([]),
  phaseTypeIds: z.union([z.uuid(), z.array(z.uuid())]).catch([]),
});
